module.exports = __webpack_public_path__ + "40794c5749f5f2337bf8964aaaddd62b.png";